import { createAction } from 'redux-actions';

export const setLoading = createAction('LOADER/SET');
